import "./patientViewer.css";
import { Header, Navigation } from "../../components/componentsIndex";
import { ShowContext } from "../../context/Context";
import { useContext } from "react";
import { Skeleton } from "antd";
import { useSearchParams } from "react-router-dom";
const PatientViewer = () => {
  const ctx = useContext(ShowContext);
  return (
    <>
      <Header />
      {ctx.loading ? (
        <Skeleton
          active
          style={{ width: "100%", maxWidth: "1024px", margin: " 20px auto" }}
        />
      ) : (
        <>
          {!ctx.wholeData && (
            <>
              <p className="intro_text">
                Click the 'Select Patient' button at the upper right to select
                the patient. If you want to add a new patient, then click the
                'Select Patient' button, and in the modal dialog that appears,
                there's a link to add a new patient.
              </p>
            </>
          )}
          {ctx.wholeData && (
            <div className="patientViewerContainer">
              <Navigation />
            </div>
          )}
          {ctx.contextHolder}
        </>
      )}
    </>
  );
};

export default PatientViewer;
